import { ReportInterface } from '../../../interfaces/report.interface';

export class SetAwaitingShiftDataReport {
    public static readonly type = '[JobsPlacements] Set awaiting shift data report';

    constructor(public report: ReportInterface) {}
}
